module.exports = __webpack_public_path__ + "static/media/Artboard 2.332945e8.png";